const routes = [

        {
          path: '/home',
          alias: "",
          name: 'Home',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import('@/views/Home.vue'),
          meta: {
            authRequired: true,
            icon: "mdi-home"
          }
        },
        {
          path: "/login",
          name: "login",
          component: () => import('@/views/Login.vue'),
          meta: {
            icon: "mdi-login",
            hidden: true
          }
        },
        {
          path: "/reset-password/:token",
          name: "reset-password",
          component: () => import('@/views/auth/ResetPassword.vue'),
          meta: {
            icon: "mdi-login",
            hidden: true
          }
        },
        {
          path: "/ask-reset-password",
          name: "ask-reset-password",
          component: () => import('@/views/auth/AskPasswordReset.vue'),
          meta: {
            icon: "mdi-login",
            hidden: true
          }
        },


        {
          path: "/utenze",
          name: "Gestione Utenze",

          component: () => import('@/components/profiler/ProfilerPage.vue'),
          
          meta: {
            icon: "mdi-security",
            authRequired: true,
            groupsRequired: [
                "admin",
                "manager"
              ],
          }
        },

        {
          path: "/clienti",
          name: "Gestione Clienti",
          meta: {
            authRequired: true,
            icon: "mdi-account-group"
          },
          component: () => import('@/views/Clienti.vue'),

          children: [
            {
              path: "",
              name: "Visualizazzione clienti",
              component: () => import('@/components/GestioneClienti.vue'),
            },
            {
              path: "/clienti/cliente/:id?",
              component: () => import('@/components/cliente/Cliente.vue'),
              name: "Gestione Cliente"
            }
          ]
        },

        {
          name: 'Grafici e statistiche',
          path: '/grafici',
          component: () => import('@/views/Grafici.vue'),
          meta: {
            authRequired: true,
            icon: "mdi-chart-line",
            groupsRequired: [
              "admin"
            ],
          },
        },

        {
          path: "/preventivi",
          name: "Gestione Preventivi",
          component: () => import('@/views/Preventivi.vue'),
          children: [
            {
              path: "",
              name: "Visualizza preventivi",
              component: () => import('@/components/preventivi/GestionePreventivi.vue'),
            },
            {
              name: "Preventivo",
              path: "preventivo/:idPreventivo?", 
              children: [
                {
                  path: "",
                  component: () => import('@/components/preventivi/Preventivo.vue'),
                  name: "Preventivo",
                },
                {
                  path: "sottoambiente/:idSottoAmbiente?",
                  component: () => import('@/views/Sottoambiente.vue'),
                  name: "Sottoambiente Preventivo"
                }
              ]
            },
          ],


          meta: {
            authRequired: true,

            icon: "mdi-file-document-edit-outline",

            groupsRequired: [
              "admin",
              "manager",
              "office"
            ],
          }
        },

        {
          path: "/ordini",
          name: "Gestione Ordini",
          component: () => import('@/views/Ordini.vue'),
          children: [
            {
              path: "",
              name: "Visualizza ordini",
              component: () => import('@/components/GestioneOrdini.vue'),
            },
            {
              name: "Ordine",
              path: "ordine/:idOrdine?",
              children: [
                {
                  path: "",
                  component: () => import('@/components/ordini/Ordine.vue'),
                  name: "Ordine",
                },
                {
                  path: "sottoambiente/:idSottoAmbiente?",
                  component: () => import('@/views/Sottoambiente.vue'),
                  name: "Sottoambiente Ordine"
                }
              ]
            },
          ],
          meta: {
            authRequired: true,
            // groupsRequired: [
            //     // "admin",
            //     // "manager"
            // ],
            icon: "mdi-package-variant-closed"
          }
        },

        {
          path: "/pagamenti",
          name: "Gestione Pagamenti",
          component: () => import('@/views/Pagamenti.vue'),
          children: [
            {
              path: "",
              name: "Visualizza Pagamenti",
              component: () => import('@/components/GestionePagamenti.vue'),
            },
          ],
          meta: {
            authRequired: true,
            groupsRequired: [
                "admin",
                "manager",
                "office"
            ],
            icon: "mdi-receipt-text"
          }
        },


        {
          path: "/aziende",
          name: "Aziende",
          meta: {
            authRequired: true,
            icon: "mdi-domain"
          },
          component: () => import('@/views/Aziende.vue'),

          children: [
            {
              path: "",
              name: "Gestione aziende",
              component: () => import('@/components/GestioneAziende.vue'),
            },
            {
              path: "azienda/:id?",
              component: () => import('@/components/aziende/Azienda.vue'),
              name: "Azienda"
            }
          ]
        },
        
        {
          path: "/scorte-magazzino",
          name: "Scorte magazzino",
          meta: {
            authRequired: true,
            icon: "mdi-warehouse"
          },
          component: () => import('@/views/ScorteMagazzino.vue'),

          children: [
            {
              path: "",
              name: "Scorte magazzino",
              component: () => import('@/components/GestioneScorteMagazzino.vue'),
            },
            {
              path: "scorta/:id?",
              component: () => import('@/components/scorta/CardScorta.vue'),
              name: "Scorta magazzino"
            }
          ]
        },
        {
            path: '/:pathMatch(.*)*',
            component: () => import('@/views/404.vue'),
            meta: {
                hidden: true
              }
        }
  ]


export default routes